import { oc } from '@orpc/contract';
import { listSegmentsInputSchema, listSegmentsOutputSchema } from '../schemas/segments.schemas.js';
export const listSegmentsContract = oc
    .route({
    method: 'GET',
    path: '/segments',
    tags: ['Segments'],
    summary: 'List vehicle segments',
})
    .input(listSegmentsInputSchema)
    .output(listSegmentsOutputSchema);
//# sourceMappingURL=list-segments.contract.js.map